const getWildcardDomain = (): string => document.location.hostname.split('.').slice(-2).join('.');

export default getWildcardDomain;
